import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '../../utils/lib/utils';

const statusColors = {
  'in transit': 'bg-blue-500',
  'delivered': 'bg-green-500',
  'processing': 'bg-yellow-500',
  'pending': 'bg-neutral-500',
  'error': 'bg-red-500'
};

export function StatusIndicator({ status, className = '' }) {
  const statusColor = statusColors[status.toLowerCase()] || 'bg-neutral-500';
  
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <div className={cn('h-2.5 w-2.5 rounded-full', statusColor)} />
      <span className="text-sm font-medium text-neutral-700 dark:text-neutral-300 capitalize">
        {status}
      </span>
    </div>
  );
}

StatusIndicator.propTypes = {
  status: PropTypes.string.isRequired,
  className: PropTypes.string
};
